__turbopack_context__.v({
  "accountForm": "settings-module__PrLJZa__accountForm",
  "content": "settings-module__PrLJZa__content",
  "menu": "settings-module__PrLJZa__menu",
  "pageContent": "settings-module__PrLJZa__pageContent",
  "roleSettingsForm": "settings-module__PrLJZa__roleSettingsForm",
  "settingsPage": "settings-module__PrLJZa__settingsPage",
  "settingsSection": "settings-module__PrLJZa__settingsSection",
  "sideBar": "settings-module__PrLJZa__sideBar",
  "uploadButton": "settings-module__PrLJZa__uploadButton",
});
